import { normalizePageSlug, pageSlugToUrl } from './pageLink'

export type StrapiPageMeta = {
  titleInternal?: string | null
  label?: string | null
  slug?: string | null
  metaTitle?: string | null
  metaDescription?: string | null
  metaOgTitle?: string | null
  metaOgDescription?: string | null
  metaOgImage?: StrapiOgImage | null
}

type StrapiOgImage = {
  url?: string | null
  localFile?: { publicURL?: string | null } | null
}

export function strapiMetaOgImageUrl(
  image?: StrapiOgImage | null
): string | undefined {
  if (image?.localFile?.publicURL) {
    const siteUri = (process.env.SITE_URI || '').replace(/\/$/, '')
    return `${siteUri}${image.localFile.publicURL}`
  }

  if (image?.url?.startsWith('http')) {
    return image.url
  }

  return undefined
}

export function createStrapiPageContext(
  page: StrapiPageMeta,
  url: string,
  breadcrumbs: MCDC.Contentful.ILinkTo[]
): MCDC.Contentful.IPageContext['page'] {
  return {
    title: page.titleInternal || page.label || '',
    url,
    breadcrumbs,
    metaTags: {
      metaTitle: page.metaTitle || page.label || '',
      metaDescription: page.metaDescription || '',
      metaOgTitle: page.metaOgTitle || undefined,
      metaOgDescription: page.metaOgDescription || undefined,
      metaOgImage: strapiMetaOgImageUrl(page.metaOgImage),
    },
  }
}

export function strapiPagePath(
  slug?: string | null,
  parentPath?: string
): string {
  const normalized = normalizePageSlug(slug)
  const segment = normalized ? `${normalized}/` : ''

  if (parentPath) {
    return `${parentPath}${segment}`
  }

  return pageSlugToUrl(slug)
}

export function strapiProfileUrl(
  offersBaseUrl: string,
  identifier?: string | null
): string {
  return `${offersBaseUrl}${identifier || ''}/`
}

export function strapiJobDetailUrl(
  profileUrl: string,
  identifier?: string | null
): string {
  return `${profileUrl}${identifier || ''}/`
}

type GatsbyNodeFields = {
  linkTo?: MCDC.Contentful.ILinkTo
  breadcrumbs?: MCDC.Contentful.ILinkTo[]
}

export function readNodeFields(
  getNode: (id: string) => unknown,
  nodeId: string
): GatsbyNodeFields | undefined {
  const node = getNode(nodeId) as { fields?: GatsbyNodeFields } | undefined
  return node?.fields
}
